<label class="csp-slide-toggle" [class.csp-slide-toggle--disabled]="disabled">
    <span *ngIf="name?.length > 0" class="{{nameClasses}}">{{name}}</span>
    <input
           type="checkbox"
           class="csp-slide-toggle__input"
           [checked]="model"
           [disabled]="disabled"
           (change)="onToggleChange($event)" />
    <span class="csp-slide-toggle__track">
        <span class="csp-slide-toggle__thumb"></span>
    </span>
</label>
